import { render } from "./HeroiconsSolidFolderOpen.vue?vue&type=template&id=5a3b440e"
const script = {}

import exportComponent from "E:\\Work\\wynajmy\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidFolderOpen.vue"]])

export default __exports__